module.exports = __webpack_public_path__ + "img/icon-404-color.4a88ae8b.svg";